/**
 * FAQ Paragraph accordions
 * - Append .active class on parent block when the question element is clicked.
 * - Slide the answer into view.
 *
 * @author Brian McGill <github.com/bmcgill>
 */

(function ($) {
  'use strict';

  let $faq;

  Drupal.behaviors.initializeFAQ = {
    attach: (context) => {
      if (context === document) {
        initialize();
      }
    },
  };

  function initialize() {
    $faq = $('.faq .faq-item');

    if (!$faq) return false;

    $faq.find('.question').on('click', function () {
      $(this).parent().toggleClass('active');
      $(this).siblings('.answer').slideToggle();
    });
  }
})(jQuery);
